/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NotificationType } from './notificationType.model';


export interface NotificationDto { 
    contractId?: number;
    contractInvalidDate?: string;
    created: string;
    detail?: string;
    id: number;
    notificationType?: NotificationType;
    perex?: string;
    readByGroup: boolean;
}
export namespace NotificationDto {
}


